import React, { Component } from "react"
import { Link, withRouter } from "react-router-dom"
import shop from "shop/shop"
import { Card, Button, Container } from "semantic-ui-react"

@withRouter
export default class AddressBook extends Component {

  state = {
    locations: []
  }

  componentDidMount() {
    shop.fetch( "/shop/rest/data/customers/current/addresses/deliver" )
      .then( locations => {
        if ( locations.length < 1 ) {
          console.info( "Keine Versandadressen vorhanden" )
          return
        }
        let locationSelected = this.state.locationSelected || locations[ 0 ].mapid
        this.setState( {
          locations,
          locationSelected
        } )
      } )
  }

  handleSelect = ( location ) => {
    shop.cart.setAddress( { location } )
    if ( this.props.backlink ) this.props.history.push( this.props.backlink || "/checkout/delivery" )
    if ( this.props.onClose ) this.props.onClose()
  }

  render() {
    const { locations } = this.state
    return (
      <div id="ok">
        <div className="tr">
          {/*<p>Wählen Sie eine Lieferadresse.</p>*/}
          {this.props.backlink && <div>
            <Link to="/checkout/delivery"><Button type="link"><i className="icon icon-cancel"/></Button></Link>
          </div>}

          {this.props.onClose && <div>
            <Button onClick={this.props.onClose} type="link"><i className="icon icon-cancel"/></Button>
          </div>}

        </div>
        <Container>
          <h2>Adressbuch</h2>
          <div className="modal-content">
            <p>Wählen Sie eine Lieferadresse:</p>
            <Card.Group itemsPerRow={4} doubling>
              {locations.map( location => {
                return <Card
                  as={"a"}
                  className="db"
                  key={location.mapid}
                  onClick={() => {
                    this.handleSelect( location )
                  }}>
                  <Card.Content>
                    <b> {location.name1}</b> <br/>
                    {location.street} <br/>
                    {location.pcode} {location.city}
                    <div className="black-60 f6">{location.email}</div>
                  </Card.Content>
                </Card>
              } )}
            </Card.Group>

            {/*<p>Wählen Sie eine Lieferadresse.</p>*/}
            {this.props.backlink && <div className="pt4">
              <Link to="/checkout/delivery"><Button type="link">Zurück</Button></Link>
            </div>}

            {this.props.onClose && <div className="pt4">
              <Button onClick={this.props.onClose} type="link">Schließen</Button>
            </div>}
          </div>
        </Container>
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/components/Address/AddressBook.js